import angular from 'angular';
// import _ from 'lodash';

class AttributDraggableTableCtrl {
  /* @ngInject */
  constructor(AuthSvc) {
    this.authSvc = AuthSvc;
  }
  $onInit() {
    this.tableOptions = { accept: true };
    this.isAuthorizedToEdit = this.authSvc.isAuthorized('CONFIGURATOR');
  }
  rowDisplayChanged(row) {
    if (!row.display) {
      row.filter = false;
    }
  }
}

angular.module('app.principal').component('kissAttributDraggableTable', {
  controller: AttributDraggableTableCtrl,
  controllerAs: 'vm',
  templateUrl: require('./attribut-draggable-table.html'),
  bindings: {
    tableData: '=',
  }
});
